import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";

const item = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="px-6 md:px-12 py-24 md:py-36 bg-paper"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-16 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-forest">
            (03) — The method
          </span>
          <h2 className="mt-4 font-display font-extrabold text-ink tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            A system built to compound.
          </h2>
          <p className="mt-6 text-ink/55 text-lg leading-relaxed">
            No guesswork, no black boxes. Every engagement follows the same disciplined
            playbook that turned 11+ brands into organic-growth stories.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-4">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              custom={i}
              variants={item}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`process-chapter-${m.no}`}
              className="relative border-t border-ink/15 pt-8 pb-10"
            >
              <span
                aria-hidden
                className="pointer-events-none select-none font-mono font-bold text-7xl md:text-8xl leading-none text-transparent"
                style={{ WebkitTextStroke: "1.5px rgba(13,54,37,0.18)" }}
              >
                {m.no}
              </span>
              <h3 className="mt-4 font-display font-bold text-2xl md:text-3xl tracking-tight text-ink">
                {m.title}
              </h3>
              <p className="mt-4 text-ink/55 text-base md:text-lg leading-relaxed max-w-md">
                {m.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
